import { Link } from "react-router-dom";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { ChevronRight, BadgeCheck } from "lucide-react";
import { CoverThumb } from "@/components/media/CoverThumb";
import type { ProducerInline } from "./types";
 
 interface ProducerInlineCardProps {
   producer: ProducerInline;
 }
 
 export function ProducerInlineCard({ producer }: ProducerInlineCardProps) {
   return (
     <Link to={`/producer/${producer.slug}`} className="block group">
       <Card className="transition-colors hover:bg-secondary/50 border-border/50">
         <CardContent className="p-4 flex items-center gap-4">
           <CoverThumb ownerType="producer" ownerId={producer.id} alt={producer.name} size={48} />
 
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-2">
                <p className="font-medium text-foreground group-hover:text-primary transition-colors truncate">
                  {producer.name}
                </p>
                {producer.isVerified && (
                  <BadgeCheck className="h-4 w-4 text-primary flex-shrink-0" />
                )}
              </div>
              {producer.shortDescription && (
                <p className="text-sm text-muted-foreground line-clamp-1">
                  {producer.shortDescription}
                </p>
              )}
             {producer.features && producer.features.length > 0 && (
               <div className="flex flex-wrap gap-1 mt-1.5">
                 {producer.features.slice(0, 3).map((feature) => (
                   <Badge
                     key={feature}
                     variant="secondary"
                     className="text-xs px-2 py-0"
                   >
                     {feature}
                   </Badge>
                 ))}
               </div>
             )}
           </div>
 
           <ChevronRight className="h-5 w-5 text-muted-foreground/50 group-hover:text-primary transition-colors flex-shrink-0" />
         </CardContent>
       </Card>
     </Link>
   );
 }